import React from 'react'
import UpdateHeader from '../3_Summary/1_UpdateHeader/UpdateHeader'
import UpdateNote from '../3_Summary/3_UpdateNote/UpdateNote'
import UpdateBody from '../3_Summary/2_UpdateBody/UpdateBody'
import { RemoveVehicleContext } from '../RemoveVehicleContext/RemoveVehicleContext'
import { AddVehicleContext } from '../AddVehicleContext/AddVehicleContext'
import { ReplaceVehicleContext } from '../ReplaceVehicleContext/ReplaceVehicleContext'

const EndorsementSummaryMain = () => {
  var screen = window.location.pathname.split("/").pop()
  var requestContext = (screen?.includes("remove")) ? RemoveVehicleContext : (screen?.includes("replace")) ? ReplaceVehicleContext : AddVehicleContext
  var endorsementType = (screen?.includes("remove")) ? "Remove Vehicle" : (screen?.includes("replace")) ? "Replace Vehicle" : "Add Vehicle"

  return (
    <>
      <UpdateHeader />
      <hr />
      <UpdateBody requestContext={requestContext} endorsementType={endorsementType} />
      <hr />
      <UpdateNote />
    </>
  )
}

export default EndorsementSummaryMain